export class DropDownItem<T> {
    
    constructor(text?: string, value?: T) {
        if (text) {
            this.text = text;
        }

        if (value !== null && typeof value !== 'undefined') {
            this.value = value;
        }
    }

    private _text : string;
    public get text() : string {
        return this._text;
    }
    public set text(v : string) {
        this._text = v;
    }
    
    
    private _value : T;
    public get value() : T {
        return this._value;
    }
    public set value(v : T) {
        this._value = v;
    }
    
    
    private _isDefault : boolean = false;
    public get isDefault() : boolean {
        return this._isDefault;
    }
    public set isDefault(v : boolean) {
        this._isDefault = v;
    }
    
    
}


// WEBPACK FOOTER //
// ./src/app/components/tx-ui-inner-3/dropdown/dropdown.item.ts